const convertImagePath = (path, width = null, height = null) => {
  // convert https://cdn.investoract.com to https://finansia.fra1.digitaloceanspaces.com
  if (path && typeof path.toLowerCase === 'function') {
    if (path.toLowerCase().includes('https://cdn.investoract.com') || path.toLowerCase().includes('https://finansia.fra1.digitaloceanspaces.com/finansia')) {
      let newPath = path
        .replace('https://cdn.investoract.com', 'https://ik.imagekit.io/investoract')
        .replace('https://finansia.fra1.digitaloceanspaces.com', 'https://ik.imagekit.io/investoract');
      if (width && height) {
        newPath = `${newPath}?tr=w-${width},h-${height},f-auto,pr-true`
      }
      return newPath
    }
  }
  return path
}

const convertImagePathToDO = (path) => {
  let newPath = path
  if (path) {
    newPath = newPath
      .replace('https://ik.imagekit.io/investoract', 'https://finansia.fra1.digitaloceanspaces.com')
      .replace('https://cdn.investoract.com', 'https://finansia.fra1.digitaloceanspaces.com')
  }

  return newPath
}

export { convertImagePath, convertImagePathToDO }